export default __webpack_public_path__ + "files/btn_close_normal.png";